var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#E88B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M41.2801 84.649C39.7831 86.146 37.356 86.146 35.8591 84.649C34.3621 83.1521 34.3621 80.725 35.8591 79.228L54.8328 60.2543L35.8591 41.2806C34.3621 39.7836 34.3621 37.3565 35.8591 35.8596C37.356 34.3626 39.7831 34.3626 41.2801 35.8596L60.2538 54.8332L79.2275 35.8596C80.7245 34.3626 83.1516 34.3626 84.6485 35.8596C86.1455 37.3565 86.1455 39.7836 84.6485 41.2806L65.6749 60.2543L84.6485 79.228C86.1455 80.725 86.1455 83.152 84.6485 84.649C83.1516 86.146 80.7245 86.146 79.2275 84.649L60.2538 65.6753L41.2801 84.649Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.02554db1325eeac293aade7306a63858.svg";
export { ForwardRef as ReactComponent };